import { Attachment, Message } from '../../../../@types/GetQuotation'
import {
  DocumentQuotation,
  MessageQuotation,
} from '../../../../@types/ResumePetisSimulationProposal'

export const mountedMessagesQuotation = (
  message: MessageQuotation[],
): Message[] => {
  const newMessages: Message[] = message.map((item) => ({
    author: item.author || '',
    date: item.creationDate || '',
    messageText: item.messageContent || '',
  }))

  return newMessages
}

export const mountedAttachmentsQuotation = (
  attachments: DocumentQuotation[],
): Attachment[] => {
  const newAttachments: Attachment[] = attachments.map((item) => ({
    date: item.documentSendDate || '',
    documentId: item.documentId || '',
    documentName: item.documentName || '',
    idExternal: item.idExternal || '',
    keyRef: item.keyRef || '',
  }))

  return newAttachments
}
